// src/js/index.ts
function isNotNull(value) {
  return value !== null && value !== void 0;
}
function requireNotNull(value, reason) {
  if (isNotNull(value)) {
    return value;
  }
  throw new Error(reason != null ? reason : "value must not be null");
}
function assertNotNull(value, reason) {
  requireNotNull(value, reason);
}
export {
  assertNotNull,
  isNotNull,
  requireNotNull
};
